import { API } from "./axiosInstance"

/**
 * Gets all the invoiceSettingMembers
 * @param {*} staticMemberId The member to get all the invoiceSettingMembers for
 * @returns the invoiceSettingMembers
 */
export const getInvoiceSettingsForMembers = async (staticMemberId) => {
    const invoiceSettingMembers = await API.get(`/invoiceSettingMembers?memberId=${staticMemberId}`);
    return invoiceSettingMembers.data;
}

/**
 * Calls the post invoiceSettingMembers endpoint
 * @param {*} invoiceSettingMembers the invoiceSettingMembers to create
 * @returns the response from usermanagement-service
 */
export const createInvoiceSettingMembers = async (invoiceSettingMember) => {
    const response = await API.post(`/invoiceSettingMembers`, invoiceSettingMember);
    return response.data;
}

/**
 * Calls the PUT invoiceSettingMembers endpoint
 * @param {*} staticId the invoiceSettingMembers to create
 * @param {*} invoiceSettingMembers the invoiceSettingMembers to create
 * @returns the response from usermanagement-service
 */
export const updateInvoiceSettingMembers = async (staticId, invoiceSettingMember) => {
    const response = await API.put(`/invoiceSettingMembers/${staticId}`, invoiceSettingMember);
    return response.data;
}


/**
 * Accepts a requested change for an invoiceSettingMembers
 * @param {*} staticId the id of the invoiceSettingMembers in the static model
 * @returns the accepted invoiceSettingMembers
 */
export const acceptChange = async(staticId) => {
    const response = await API.post(`/invoiceSettingMembers/${staticId}/accept`);
    return response.data;
}


/**
 * Rejects a requested change for an invoiceSettingMembers
 * @param {*} staticId the id of the invoiceSettingMembers in the static model
 * @returns the accepted invoiceSettingMembers
 */
export const rejectChange = async(staticId) => {
    const response = await API.post(`/invoiceSettingMembers/${staticId}/reject`);
    return response.data;
}